import coleta from './coleta';

// ==============================|| MENU ITEMS ||============================== //
const menuColeta = {
  items: [coleta]
};

export default menuColeta;
